let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("czPXX")).then(() => parcelRequire('3pKEh'));